module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('Guia', {
    attrs: {
      "showGuia": _vm.showGuia,
      "consulta": _vm.formData
    }
  }), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.formData.result && _vm.formData.result.tipo_status.bloqueado == 0) ? _c('div', {
    staticClass: "col-md-12 text-center mt-5"
  }, [(_vm.formData.id_tipo_status == 54) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "size": "big",
      "loading": _vm.loadingSave,
      "value": "Salvar Consulta"
    },
    on: {
      "click": _vm.salvar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center mt-2"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-file-pdf-o",
      "type": "warning",
      "size": "big",
      "value": "Gerar Guia de Encaminhamento"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1)], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.formData.result.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir ASO"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1)], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 194)) ? _c('div', {
    staticClass: "col-12 mt-5 text-left"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Essa consulta está aguardando processamento. Espere alguns minutos e atualize essa página para verificar o andamento do registro da consulta.",
      "title": "Atenção"
    }
  })], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 195)) ? _c('div', {
    staticClass: "col-12 mt-5 text-left"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Erro ao registrar a consulta: ' + _vm.formData.result.info,
      "title": "Atenção"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id != 194 && _vm.formData.result.tipo_status.id != 195) ? _c('el-tab-pane', {
    attrs: {
      "label": "Exames Complementares",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v(" Exames Complementares")]), _vm._v(" "), _c('Exames')], 1) : _vm._e(), _vm._v(" "), (_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id != 194 && _vm.formData.result.tipo_status.id != 195) ? _c('el-tab-pane', {
    attrs: {
      "label": "Riscos Ocupacionais",
      "name": "tab-riscos"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Riscos Ocupacionais")]), _vm._v(" "), _c('Riscos')], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Acompanhamento",
      "name": "tab-acompanhamento"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" Acompanhamento")]), _vm._v(" "), _c('Acompanhamento')], 1), _vm._v(" "), (_vm.formData.result) ? _c('el-tab-pane', {
    attrs: {
      "label": "Exames no PCMSO",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.formData.result.ghe.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.result) ? _c('el-tab-pane', {
    attrs: {
      "label": "Histórico de Consultas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('Historico', {
    attrs: {
      "funcionario": _vm.formData.result.funcionario,
      "id_funcao": _vm.formData.result.funcao.id
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac6745ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/editar.vue
// module id = 1484
// module chunks = 44